<template>
	<v-row class='my-16'>
		<v-col>
			<v-card rounded class='opaque' elevation="10" >
				<v-toolbar color='primary' dark outlined>
					<v-toolbar-title class='text-h4 font-weight-light text-uppercase' v-text='title' />
				</v-toolbar>
				<v-tabs background-color='primary' center-active dark grow icons-and-text slider-color='secondary' v-model='tab'>
					
					<v-tab v-show='false'><!-- Top tab belongs to service overview --></v-tab>

					<v-tab-item class='pa-8 pt-6' >
						<h3 class='text-h3'>Overview</h3>
						<h2 class='text-h5'>Select service to learn more</h2>
						
						<Services :services='items' @show-service='setTabIndex' />
					</v-tab-item>

					<template v-for='(item, index) in items'>
						<!-- TAB HEADERS -->
						<v-tab :key='`tab-${index}`' :style='{ width: width }' class='pa-1' >
							{{ item.title }}
							<v-img :src='item.icon' class='elevation-3 ma-2' contain max-height='64' max-width='64' />
						</v-tab>

						<v-tab-item :key='`content-${index}`'>
							<service-tab-content v-bind='item' :index='index' @show-overview='tab = 0' />
						</v-tab-item>
					</template>
				</v-tabs>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import Services from '@/components/n-collections/PrimarServices'
import ServiceTabContent from '@/components/n-collections/n-items/ServiceTabItem'

export default {
	data() {
		return {
			tab: 0,
		}
	},
	props: {
		title: String,
		items: Array,
		width: {
			type: String,
			default: '264px',
		},
	},
	methods: {
		setTabIndex(index) {
			this.tab = index+1
		}
	},
	components: {
		Services,
		ServiceTabContent
	},
}
</script>

<style lang="scss">
.tabs .v-item-group {
	height: 140px !important;
}
.v-tabs--icons-and-text > .v-tabs-bar {
	height: 140px !important;
}

.v-window__container {
	height: 100% !important;
}
</style>
